import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Danh sách biên bản giải thể")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DissolutionReportTableList = _resolveComponent("DissolutionReportTableList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DissolutionReportTableList, {
          items: _ctx.plans,
          onUpdateTable: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData()))
        }, null, 8, ["items"])
      ])
    ])
  ]))
}